import { classNames } from "@/shared/utils/classnames";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC, ReactNode } from "react";
import toast, { Toast as IToast } from "react-hot-toast";

export type ToastProps = {
  t: IToast;
  icon?: IconDefinition;
  image?: string;
  body?: ReactNode | string;
  title?: string;
  variant?: "primary" | "secondary" | "success" | "danger" | "warning" | "info";
};

export const Toast: FC<ToastProps> = ({
  t,
  icon,
  image,
  title,
  body,
  variant = "secondary",
}) => {
  const iconClassNames = {
    primary: "text-primary bg-white",
    secondary: "text-black bg-gray-200",
    success: "text-green-500 bg-green-200",
    danger: "text-red-500 bg-red-200",
    warning: "text-yellow-500 bg-yellow-200",
    info: "text-blue-500 bg-blue-200",
  };

  return (
    <div
      className={classNames(
        "flex items-center w-full max-w-xs p-4 text-gray-500 bg-white rounded-md shadow z-[9999]",
        t.visible ? "animate-enter" : "animate-leave"
      )}
      role="alert"
    >
      {icon ? (
        <div
          className={classNames(
            "inline-flex items-center justify-center flex-shrink-0 w-12 h-12 rounded-md",
            iconClassNames[variant]
          )}
        >
          <FontAwesomeIcon icon={icon} className="text-xl" />
        </div>
      ) : (
        <img className="w-12 h-12 rounded-md" src={image} />
      )}
      <div className="flex flex-col">
        <div className="ms-3 text-sm font-bold">{title}</div>
        <div className="ms-3 text-sm font-normal">{body}</div>
      </div>
      <button
        type="button"
        className="ms-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-md focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8"
        data-dismiss-target="#toast-default"
        aria-label="Close"
        onClick={() => toast.dismiss(t.id)}
      >
        <span className="sr-only">Close</span>
        <svg
          className="w-3 h-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 14 14"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
          />
        </svg>
      </button>
    </div>
  );
};
